(function(){
  if(window.__tcMega)return; window.__tcMega=1;  // snippet HEM desktop HEM mobil header'da -> JS 2x yuklenir; tek sefer calis (yoksa toggle iptal olur, kapanmaz)
  function ready(f){if(document.readyState!=='loading')f();else document.addEventListener('DOMContentLoaded',f)}
  ready(function(){
    // desktop: hover-intent (etiket->panel gecisinde kapanmasin; alan disinda gecikmeyle kapansin)
    var items=document.querySelectorAll('.tc-mm-item'), closeT;
    items.forEach(function(it){
      var rail=it.querySelectorAll('.tc-mm-rbtn'), grps=it.querySelectorAll('.tc-mm-grp');
      rail.forEach(function(b){b.addEventListener('mouseenter',function(){
        var i=b.getAttribute('data-i');
        rail.forEach(function(x){x.classList.toggle('tc-mm-on',x.getAttribute('data-i')===i)});
        grps.forEach(function(g){g.classList.toggle('tc-mm-on',g.getAttribute('data-i')===i)});
      })});
      it.addEventListener('mouseenter',function(){
        clearTimeout(closeT);
        items.forEach(function(x){x.classList.remove('tc-mm-active')});
        it.classList.add('tc-mm-active');
      });
      it.addEventListener('mouseleave',function(){
        clearTimeout(closeT);
        closeT=setTimeout(function(){it.classList.remove('tc-mm-active')},220);
      });
    });
    // mobil accordion - 1.seviye (Kadin/Erkek..) + 2.seviye (Giyim/Elbise..). Her tap kendi parent'ini toggle eder
    document.querySelectorAll('.tc-mm-mtop:not(.tc-mm-mtop--link),.tc-mm-mtop2').forEach(function(t){
      t.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();t.parentNode.classList.toggle('tc-mm-open')});
    });
    // mobil drawer ac/kapa: tema hamburger butonunu yakala
    // ONEMLI: snippet HEM desktop HEM mobil header'da var -> 2 drawer. querySelectorAll ile HEPSINE show ekle (gorunur olan mobil header'daki acilir; desktop'taki parent display:none kalir)
    var drs=document.querySelectorAll('.tc-mm-mdrawer'), bks=document.querySelectorAll('.tc-mm-mback');
    function open(){drs.forEach(function(d){d.classList.add('tc-mm-show')});bks.forEach(function(b){b.classList.add('tc-mm-show')})}
    function close(){drs.forEach(function(d){d.classList.remove('tc-mm-show')});bks.forEach(function(b){b.classList.remove('tc-mm-show')})}
    bks.forEach(function(b){b.addEventListener('click',close)});
    document.querySelectorAll('.tc-mm-mclose').forEach(function(x){x.addEventListener('click',close)});
    document.addEventListener('click',function(e){
      var t=e.target.closest('.item__mobile--hamburger,.header-mobile--hamburger,[data-drawer-toggle],.halo-menu-icon,.header__icon--menu,.mobile-nav-toggle,.js-mobile-nav-toggle,[aria-label="Menu"],[aria-label="Menü"]');
      if(t){e.preventDefault();e.stopImmediatePropagation();open()}
    },true);
    window.tcMegaOpen=open; // yedek tetikleyici
  });
})();